import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const PLACES = [
  ["BTR Airport", "~15 min", ""],
  ["Downtown Baton Rouge", "~15–20 min", ""],
  ["LSU & the Lakes", "~20 min", ""],
  ["Donaldsonville", "~15 min", "from Heritage · Ascension Parish"],
  ["St. Francisville", "~35 min", "from Baker"],
  ["Plant Corridor · Geismar", "~15–30 min", ""],
];

export default function AreaGuide() {
  return (
    <section data-testid="area-guide" className="bg-[#16301f] text-[#f7f2e7]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="flex flex-wrap items-end justify-between gap-6 mb-12"
        >
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#f7f2e7]/60 flex items-center gap-4">
              <span className="h-px w-12 bg-[#f7f2e7]/40 inline-block" />
              The Area
            </p>
            <h2 className="font-display font-medium text-4xl sm:text-5xl mt-5">Perfectly placed</h2>
          </div>
          <p className="font-script text-3xl sm:text-4xl text-[#f7f2e7]/85 -rotate-1">
            Close to everything that brings you here.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 border-t border-l border-[#f7f2e7]/15">
          {PLACES.map(([place, time, origin], i) => (
            <motion.div
              key={place}
              data-testid={`area-${place.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: EASE }}
              className="border-b border-r border-[#f7f2e7]/15 p-6 sm:p-8 hover:bg-[#1a3324] transition-colors duration-500"
            >
              <MapPin className="w-5 h-5 text-[#c9a227]" strokeWidth={1.5} />
              <h3 className="font-display text-lg sm:text-xl mt-4">{place}</h3>
              <p className="text-xs text-[#f7f2e7]/55 font-light mt-1.5">{time} drive</p>
              {origin && (
                <p className="text-[10px] uppercase tracking-[0.18em] text-[#c9a227]/70 mt-1">{origin}</p>
              )}
            </motion.div>
          ))}
        </div>
        <p className="text-[10px] uppercase tracking-[0.22em] text-[#f7f2e7]/40 mt-6">
          Approximate drive times from our Baker &amp; Ascension Parish residences
        </p>
      </div>
    </section>
  );
}
